"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakPoint = exports.layoutIndent = exports.FONTS = exports.COLORS = void 0;
exports.COLORS = {
    // darkGrey: '#656565',
    outlineGrey: '#EBEBEB',
    // blue: '#007AE5',
    // lightBlue: '#7ABCFF',
    // red: '#FF2323',
    lightRed: '#FC7474',
    lightPink: '#FCDCDC',
    yellow: '#FFD400',
    lightYellow: '#FFE200',
    lightGreen: '#27AE60',
    GRAY_DARK: '#181B21',
    GRAY_XL: '#393C41',
    GRAY_L: '#5C5E62',
    GRAY_M: '#74767A',
    GRAY_S: '#C5C6C7',
    GRAY_XS: '#F5F5F5',
    RED_FIRM: '#E30813',
    RED_LIGHT: '#FAF3F4',
    BRIGHT_BLUE: '#007BFF',
    BLUE: '#3997FB',
    BLUE_GREY: '#C6D7E9',
    LIGHT_BLUE: '#F4F6FB',
    GREY_BLUE: '#7F8FA0',
    WHITE: '#FFFFFF',
    TRANSPARENT: 'transparent',
    'RED_GRADIENT': 'linear-gradient(179.99deg, #E30813 0.01%, #BE241E 99.99%)',
    'RED_WHITE_GRADIENT': 'radial-gradient(100% 161.09% at 100% 0%, rgba(227, 8, 19, 0.15) 0%, rgba(227, 8, 19, 0) 100%), #FFFFFF',
    'RED_TRANSPARENT_GRADIENT': 'radial-gradient(100% 161.09% at 100% 0%, rgba(227, 8, 19, 0.15) 0%, rgba(227, 8, 19, 0) 100%)',
    darkGrey: '#505050',
    middleGray: '#7F8FA0',
    white: '#FFFFFF',
    brightBlue: '#007BFF',
    blue: '#0FC8F9',
    blueHover: '#3997FB',
    green: '#30BF90',
    red: '#EC8F8F',
    fullBlack: '#000000',
    darkBlue: '#00509E',
    // NEW COLORS
    // Константы разным кейсом были до этого, оставил для обратной совместимости
    black: '#282828',
    grey: '#575757',
    greyBlue: '#97A6B7',
    averageDarkGrey: '#969696',
    greyNav: '#BDBDBD',
    baseGray: '#131516',
    lightGrey: '#D9DBDE',
    GRAY_LIGHT: '#F0F0F0',
    blackBlue: '#171C25',
    blueDark: '#002041',
    lightBlue: '#F4F4F9',
    BLUE_BLUE_LIGHT: '#D0F0FF',
    BARDO_LINE: '#B9022E',
    PINK_BRIGHT: '#F62660',
    PINK: '#FD5F8B',
    YELLOW: '#E4F152',
    GREEN: '#30BF90',
    RED: '#EC8F8F',
};
var FONTS;
(function (FONTS) {
    FONTS["H0"] = "font: var(--bold-h0); letter-spacing: -0.03em;";
    FONTS["H1"] = "font: var(--bold-h1); letter-spacing: -0.03em;";
    FONTS["H2"] = "font: var(--bold-h2);";
    FONTS["H3"] = "font: var(--bold-h3);";
    FONTS["H4"] = "font: var(--bold-h4);";
    FONTS["H5"] = "font: var(--bold-h5);";
    FONTS["Medium"] = "font: var(--medium);";
    FONTS["XXL"] = "font: var(--regular-xxl); letter-spacing: -0.01em;";
    FONTS["XL"] = "font: var(--regular-xl); letter-spacing: -0.01em;";
    FONTS["L"] = "font: var(--regular-l);";
    FONTS["M"] = "font: var(--regular-m);";
    FONTS["S"] = "font: var(--regular-s);";
    FONTS["XS"] = "font: var(--regular-xs);";
    FONTS["XXS"] = "font: var(--regular-xxs);";
})(FONTS = exports.FONTS || (exports.FONTS = {}));
exports.layoutIndent = 32;
/**
 * Layout breakpoints
 * @param {(number|string)} media - алиас макета
 * @return {string}
 */
function breakPoint(media) {
    switch (media.toString()) {
        case '1366':
            return 'max-width: 1599px';
        case '1024':
            return 'max-width: 1279px';
        case '768':
            return 'max-width: 1023px';
        case '320':
            return 'max-width: 767px';
        default:
            return 'max-width: auto';
    }
}
exports.breakPoint = breakPoint;
